module.exports = __webpack_public_path__ + "static/img/great.5761e5f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/great.gif
// module id = FzIJ
// module chunks = 56